import React, {useState, useEffect} from 'react';
import api from '../../core/api';
import {List, CircularProgress} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {useAppContext} from '../singletons/AppContext';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
}));
export default function PartnerContainer({key, children}) {
  const [state, setState] = useState({
    partners: [],
    loading: true,
    error: null,
  });
  const {setAppState} = useAppContext();
  const idEmpresa = parseInt(localStorage.getItem('empresa_id'));
  const adminGestor = JSON.parse(localStorage.getItem('adminGestor'));

  const classes = useStyles();

  /**
   *
   * @param {import('axios').AxiosInstance} api
   */
  async function fetchData() {
    setState({
      partners: [],
      loading: true,
      error: null,
    });

    try {
      const {data: partners} = await api.get(`/partners`);
      const partnersToOrderName = partners.map(partner => {
        const name = partner.artisticName || partner.name;
        partner.orderName = name;
        return partner;
      });

      setState({
        ...state,
        partners: partnersToOrderName,
        loading: false,
      });
    } catch (e) {
      if (e.response)
        setState({
          ...state,
          error: {
            payload: e.response.data,
          },
        });
      else setState({...state, error: {}});
    }
  }

  useEffect(() => {
    fetchData();
    setAppState({onReloadData: () => fetchData()});
  }, []);

  if (state.error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchData}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  if (state.loading) {
    return (
      <div className="flex-col center-a center-b" style={{height: '50vh'}}>
        <span style={{paddingTop: '10em'}}>
          <CircularProgress size={100} />
          <p> Carregando... </p>
        </span>
      </div>
    );
  }

  return (
    <List className={classes.root}>
      {children({
        partners: state.partners.sort((a, b) => {
          if (a.orderName > b.orderName) {
            return 1;
          }
          if (a.orderName < b.orderName) {
            return -1;
          }
          return 0;
        }),
        fetchData,
      })}
    </List>
  );
}
